import { createContext, useContext } from 'react';

export const AuthContext = createContext<any>(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        // We don't throw error here because some components might render 
        // before the provider is fully set up in initial loads, 
        // but generally it should be within a provider.
    }
    return context;
};
